import { useContext } from 'react';

import { FormReadOnlyContext } from '../contexts/form';

export function useFormReadOnly(fieldReadOnly?: boolean): boolean {
  const contextReadOnly = useContext(FormReadOnlyContext);
  return contextReadOnly || fieldReadOnly || false;
}
